var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{staticClass:"bg-yellow"},[_c('h2',{staticClass:"fs-l fw-l"},[_vm._v("Get in touch")]),_c('a',{staticClass:"fs-m",attrs:{"href":"mailto:saso.smark@gmail.com"}},[_vm._v("saso.smark@gmail.com")])])}
var staticRenderFns = []

export { render, staticRenderFns }